import React, { FunctionComponent } from 'react';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { TRANSLATION_NAMESPACE } from 'directory/listings/notification-modals/constants';
import { CancelConfirmationModalProps } from 'directory/listings/notification-modals/types';
import 'directory/listings/notification-modals/components/UpdatingFlow/CancelConfirmationModal.scss';

export const CancelConfirmationModal: FunctionComponent<CancelConfirmationModalProps> = ({
    show,
    onDoNotCancel,
    onConfirmCancel,
    disabled = false,
}) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACE);

    return (
        <Modal
            show={show}
            onHide={onDoNotCancel}
            centered
            backdrop
            keyboard
            className="cancel-confirmation-modal"
            backdropClassName="cancel-confirmation-modal-backdrop"
        >
            <Modal.Header closeButton />
            <Modal.Body className="cancel-confirmation-modal__body">
                <div className="cancel-confirmation-modal__icon-wrapper">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        size="2x"
                        className="cancel-confirmation-modal__icon"
                    />
                </div>

                <h4 className="cancel-confirmation-modal__title">{t('CANCEL_UPDATE_TITLE')}</h4>

                <p className="cancel-confirmation-modal__message">{t('CANCEL_UPDATE_MESSAGE')}</p>

                <div className="cancel-confirmation-modal__actions">
                    <Button
                        variant="outline-primary"
                        onClick={onDoNotCancel}
                        className="cancel-confirmation-modal__btn-no rounded-btn outline-btn-color"
                    >
                        {t('CONTINUE_UPDATING')}
                    </Button>
                    <Button
                        variant="danger"
                        onClick={onConfirmCancel}
                        className="cancel-confirmation-modal__btn-yes rounded-btn"
                        disabled={disabled}
                    >
                        {t('CANCEL')}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
